<template>
  <div v-if="originalInsidersImage !== ''" class="photo-card-container">
    <div class="photo-card">
      <img
        v-if="newInsiderImageUrl !== ''"
        :src="`${newInsiderImageUrl}`"
        class="photo-image"
      />
      <img
        v-else-if="originalInsidersImage !== ''"
        :src="`${baseImageUrl}/uploads/city/${cityId}/${originalInsidersImage}`"
        class="photo-image"
      />
      <div class="photo-content">
        <div>
          <div class="photo-header">
            <h1>{{ title }}</h1>
          </div>
          <p class="photo-input-label">
            Image Description <i>(for screen readers)</i>
          </p>
          <textarea
            class="photo-input-area"
            v-model="img_description"
            @input="updateInsidersImageData()"
            :disabled="!canEdit"
          ></textarea>
          <p class="validation-error">
            <span v-if="validations && validations.$iter[index].$invalid"
              >Description is Required.</span
            >
          </p>
        </div>
        <div v-if="canEdit" class="photo-actions">
          <a></a>
          <a @click="removeImage(photos)"><b>Delete Image</b></a>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="photos.length === 0 && originalInsidersImage === '' && newInsiderImageUrl === ''"></div>
  <div v-else-if="photos.length > 0" class="photo-card-container">
    <div
      v-for="(photo, index) in sortedPhotos"
      :key="photo._id"
      class="photo-card"
    >
      <img :src="getImageUrl(photo)" class="photo-image" />
      <div class="photo-content">
        <div>
          <div v-if="photo.featured" class="photo-header">
            <h1>{{ title }}</h1>
          </div>
          <div v-else class="photo-header"><p>Secondary Image</p></div>
          <p class="photo-input-label">
            Image Description <i>(for screen readers)</i>
          </p>
          <textarea
            class="photo-input-area"
            v-model="photo.description"
            @input="updatePhotosData()"
            :disabled="!canEdit"
          ></textarea>
          <p class="validation-error">
            <span v-if="validations && validations.$iter[index].$invalid"
              >Description is Required.</span
            >
          </p>
        </div>
        <div v-if="canEdit" class="photo-actions">
          <a @click="setImageAsFeatured(photo)">{{
            photo.featured ? '' : 'Set as Featured'
          }}</a>
          <a @click="removeImage(photo)"><b>Delete Image</b></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseImageUrl: process.env.VUE_APP_S3_BASE_URL,
      img_description: this.insiderImageDescription,
    };
  },
  props: {
    photos: {
      type: Array,
    },
    validations: {
      type: Object,
    },
    cityId: {
      type: Number,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Featured Image',
    },
    originalInsidersImage: {
      type: String,
      default: '',
    },
    newInsiderImageUrl: {
      type: String,
      default: '',
    },
    insiderImageDescription: {
      type: String,
      default: '',
    },
  },
  computed: {
    sortedPhotos() {
      return [...this.photos].sort((a, b) => b.featured - a.featured);
    },
  },
  methods: {
    updatePhotosData() {
      this.$emit('update:photos', this.photos);
    },
    updateInsidersImageData() {
      this.$emit('update-insiders-img-description', this.img_description);
    },
    removeImage(image) {
      if (this.photos.length > 0) {
        this.$emit('remove-image', image);
        return;
      }
      this.$emit('remove-insiders-image', image);
      this.img_description = '';
    },
    setImageAsFeatured(image) {
      this.$emit('set-featured', image);
    },
    getImageUrl(photo) {
      if (photo.tempUrl) {
        return photo.tempUrl;
      }

      return `${this.baseImageUrl}/uploads/city/${this.cityId}/${photo.image}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.validation-error {
  margin: 0;
  height: 1rem;
  color: red;
  font-size: 0.875rem;
}
.photo-card-container {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  .photo-card {
    border-radius: var(--rounded-2xl);
    background: white;
    box-shadow: 0.1rem 0.1rem 0.75rem 0px rgba(0, 0, 0, 0.25);
    height: 28rem;
    width: 20rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .photo-image {
      width: auto;
      height: 10.5rem;
      border-top-left-radius: 1rem;
      border-top-right-radius: 1rem;
    }

    .photo-content {
      padding: 1.25rem;
      height: 100%;

      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .photo-header,
      .photo-header * {
        margin-top: 0;
        margin-bottom: 0;

        font-size: 1rem;
        h1 {
          color: #0a1f44;
          font-style: normal;
          font-weight: 500;
          line-height: 1.875rem;
        }
      }

      .photo-input-label {
        margin-top: 0.8rem;
        margin-bottom: 0;
        color: black;
        font-size: 0.875rem;
      }

      .photo-input-area {
        margin-top: 0.5rem;
        width: 100%;
        resize: none;
        border-color: #949494;
        height: 6.5rem;
        font-size: 0.875rem;
        padding: 5px;
      }

      .photo-actions {
        display: flex;
        justify-content: space-between;
        font-size: 0.8rem;
        a {
          margin: 0;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
